import {
  Component, ElementRef,
  EventEmitter,
  HostListener,
  Input, OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'ngx-verify-code',
  templateUrl: 'ngx-verify-code.component.html',
  styleUrls: ['ngx-verify-code.component.less'],
})
export class NgxVerifyCodeComponent implements OnInit, OnDestroy {
  /**
   * ç»å¸å®½åº¦
   */
  @Input() width = 310;
  /**
   * ç»å¸é«åº¦
   */
  @Input() height = 155;
  /**
   * è·åå¾çå°å
   */
  @Input() getImageUrl: (width: number, height: number) => string;
  /**
   * éªè¯æååè°
   */
  @Output() success: EventEmitter<void> = new EventEmitter<void>();
  /**
   * éªè¯å¤±è´¥åè°
   */
  @Output() fail: EventEmitter<void> = new EventEmitter<void>();
  /**
   * è§¦åå·æ°äºä»¶, åæ°ä¸ºæ¯å¦ä¸ºèªå¨å·æ°, false: æå¨å·æ°
   */
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('canvasRef') canvasRef: ElementRef;
  @ViewChild('blockRef') blockRef: ElementRef;

  /**
   * æ»ååå¾
   */
  private readonly r = 9;
  /**
   * æ»åè¾¹é¿
   */
  private readonly sliderLength = 42;
  private readonly PI = Math.PI;
  private readonly L = this.sliderLength + this.r * 2 + 3;
  private canvasCtx: CanvasRenderingContext2D;
  private blockCtx: CanvasRenderingContext2D;
  private codeX: number;
  private originX: number;
  private originY: number;
  /**
   * æå¨è½¨è¿¹
   */
  private trail: number[] = [];
  /**
   * æå¨çXè·ç¦»
   */
  moveX: number ;
  /**
   * é¼ æ å·¦é®æ¯å¦æä¸
   */
  isMouseDown = false;
  /**
   * æ¼å¾éªè¯ç Leftå¼
   */
  blockLeft: number;
  /**
   * æ¼å¾éªè¯ç çå®½åº¦
   */
  blockWidth = this.width;
  /**
   * æ¯å¦éªè¯æå
   */
  verifySuccess: boolean;
  /**
   * æ¯å¦å¤äºå è½½ç¶æ
   */
  loading = false;

  constructor(protected render: Renderer2) {
    this.getImageUrl = (w, h) => `https://picsum.photos/${w}/${h}/?image=${this.getRandomByRange(0, 1084)}`;
  }

  ngOnInit() {
    this.canvasCtx = (this.canvasRef.nativeElement as HTMLCanvasElement).getContext('2d');
    this.blockCtx = (this.blockRef.nativeElement as HTMLCanvasElement).getContext('2d');
    this.reset();
    this.render.listen('document', 'mousemove', this.dragMoveHandle.bind(this));
    this.render.listen('document', 'touchmove', this.dragMoveHandle.bind(this));
    this.render.listen('document', 'mouseup', this.dragEndHandle.bind(this));
    this.render.listen('document', 'touchend', this.dragEndHandle.bind(this));
  }

  /**
   * éç½®
   * @param autoRefresh æ¯å¦æ¯èªå¨å·æ°
   */
  reset(autoRefresh: boolean = true): void {
    this.loading = true;
    this.verifySuccess = null;
    this.blockWidth = this.width;
    this.blockRef.nativeElement.width = this.width;
    this.canvasCtx.clearRect(0, 0, this.width, this.height);
    this.blockCtx.clearRect(0, 0, this.width, this.height);
    this.blockLeft = 0;
    this.moveX = 0;

    this.refresh.emit(autoRefresh);

    this.createImage(evt => {
      this.loading = false;
      // éæºåå»ºæ»åçä½ç½®
      this.codeX = this.getRandomByRange(this.L + 10, this.width - (this.L + 10));
      const y = this.getRandomByRange(10 + this.r * 2, this.height - (this.L + 10));
      this.draw(this.canvasCtx, this.codeX, y, ctx => ctx.fill());
      this.draw(this.blockCtx, this.codeX, y, ctx => ctx.clip());
      this.canvasCtx.drawImage(evt, 0, 0, this.width, this.height);
      this.blockCtx.drawImage(evt, 0, 0, this.width, this.height);

      const yy = y - this.r * 2 - 1;
      const ImageData = this.blockCtx.getImageData(this.codeX - 3, yy, this.L, this.L);
      this.blockRef.nativeElement.width = this.L;
      this.blockCtx.putImageData(ImageData, 0, yy);
    });
  }

  /**
   * ç»å¶æ¼å¾å¾æ 
   * @param ctx CanvasContextå¯¹è±¡
   * @param x xåæ 
   * @param y xåæ 
   * @param operation æä½åè°
   */
  protected draw(ctx: CanvasRenderingContext2D, x: number, y: number, operation?: (ctx: CanvasRenderingContext2D) => void) {
    ctx.beginPath();
    // left
    ctx.moveTo(x, y);
    ctx.arc(x + this.sliderLength / 2, y - this.r + 2, this.r, 0.72 * this.PI, 2.26 * this.PI);
    ctx.lineTo(x + this.sliderLength, y);
    // right
    ctx.arc(x + this.sliderLength + this.r - 2, y + this.sliderLength / 2, this.r, 1.21 * this.PI, 2.78 * this.PI);
    ctx.lineTo(x + this.sliderLength, y + this.sliderLength);
    ctx.lineTo(x, y + this.sliderLength);
    // bottom
    ctx.arc(x + this.r - 2, y + this.sliderLength / 2, this.r + 0.4, 2.76 * this.PI, 1.24 * this.PI, true);
    ctx.lineTo(x, y);
    ctx.lineWidth = 1;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
    ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)';
    ctx.stroke();
    if (operation) {
      operation(ctx);
    }
    ctx.globalCompositeOperation = 'destination-over';
  }

  /**
   * åå»ºImage
   * @param onload å¾çå è½½æåçåè°
   */
  private createImage(onload: (evt: HTMLImageElement) => any) {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = () => onload(img);
    img.onerror = () => img.src = this.getImageUrl(this.width, this.height);
    img.src = this.getImageUrl(this.width, this.height);
  }

  @HostListener('selectstart', ['$event.target'])
  selectStart(el: HTMLElement) {
    return false;
  }

  /**
   * å·æ°æé®ç¹å»æ¶é´
   */
  refreshClick() {
    if (this.loading || this.verifySuccess) {
        return ;
    }
    this.reset(false);
  }

  /**
   * ææ½å¼å§çå¤ç
   * @param evt äºä»¶,å¼å®¹ç§»å¨ç«¯åPC
   */
  dragStartHandle(evt: MouseEvent & TouchEvent) {
    if (this.loading || this.verifySuccess) {
      return ;
    }
    this.originX = evt.clientX || evt.touches[0].clientX;
    this.originY = evt.clientY || evt.touches[0].clientY;
    this.isMouseDown = true;
  }

  /**
   * ææ½ç§»å¨çå¤ç
   * @param evt äºä»¶,å¼å®¹ç§»å¨ç«¯åPC
   */
  protected dragMoveHandle(evt: MouseEvent & TouchEvent) {
    if (!this.isMouseDown) {
      return false;
    }

    const eventX = evt.clientX || evt.touches[0].clientX;
    const eventY = evt.clientY || evt.touches[0].clientY;
    const moveX = eventX - this.originX;
    const moveY = eventY - this.originY;

    if (moveX < 0 || moveX + 38 >= this.width) {
      return false;
    }

    this.moveX = moveX;
    this.blockLeft = (this.width - 40 - 20) / (this.width - 40) * moveX;
    this.trail.push(moveY);
  }

  /**
   * ææ½ç»æçå¤ç
   * @param evt äºä»¶,å¼å®¹ç§»å¨ç«¯åPC
   */
  protected dragEndHandle(evt: TouchEvent & MouseEvent) {
    if (!this.isMouseDown) {
      return false;
    }

    this.isMouseDown = false;
    const eventX = evt.clientX || evt.changedTouches[0].clientX;
    if (eventX === this.originX) {
      return false;
    }

    const { spliced, verified } = this.verify();
    if (spliced && verified) {
        this.verifySuccess = true;
        this.success.emit();
        return;
    }
    this.verifySuccess = false;
    this.fail.emit();
    setTimeout(() => {
      this.verifySuccess = null;
      this.reset();
    }, 1500);
  }

  /**
   * éªè¯ç»æ
   */
  verify(): {spliced: boolean, verified: boolean} {
    const sum = (x, y) => x + y;
    const average = this.trail.reduce(sum, 0) / this.trail.length;
    const deviations = this.trail.map(x => x - average);
    const stddev = Math.sqrt(deviations.map(x => x * x).reduce(sum, 0) / this.trail.length);

    this.trail = [];
    return {
      // xè½´éªè¯ç»æ
      spliced: Math.abs(this.blockLeft - this.codeX) < 3,
      // yè½´éªè¯ç»æ
      verified: stddev !== 0
    };
  }

  ngOnDestroy(): void {
    this.render.destroy();
  }

  /**
   * è·åå¾çid,ä»èå´ä¸­éæº
   * @param start å¼å§
   * @param end ç»æ
   * @return è¿åéæºå¼
   */
  private getRandomByRange(start, end): number {
    return Math.round(Math.random() * (end - start) + start);
  }
}
